module.exports = __webpack_public_path__ + "img/game_glotto_x.960e6dd.jpg";